var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "sidebar-image" }, [
    _vm.url
      ? _c(
          "a",
          {
            staticClass: "sidebar-image-link",
            attrs: { href: _vm.url, target: "_blank", rel: "noopener" },
          },
          [
            _c("img", {
              staticClass: "sidebar-image-img",
              attrs: { src: _vm.url, alt: _vm.item.Name || "" },
            }),
          ]
        )
      : !_vm.loaded
      ? _c(
          "div",
          { staticClass: "sidebar-loading" },
          [_c("w-progress-circular", { attrs: { small: "" } })],
          1
        )
      : _c(
          "div",
          { staticClass: "sidebar-image-placeholder" },
          [
            _c("w-fa", { attrs: { icon: "image" } }),
            _c("span", [_vm._v(_vm._s(_vm.$ct("sidebar.product-image.none")))]),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }